import React from 'react'
import { UsersTable } from './UsersTable'
import withStyles from '@material-ui/core/styles/withStyles'
import Paper from '@material-ui/core/Paper'
import styles from '../../../styles'

export class UsersAdminPage extends React.Component {
    render() {
        return (
            <Paper className={this.props.classes.adminTablePaper} elevation={1}>
                <UsersTable  />
                </Paper>
        )
    }
}

UsersAdminPage = withStyles( styles, {withTheme: true} )(UsersAdminPage)


// WEBPACK FOOTER //
// ./src/App/Admin/User/UsersAdminPage.jsx